import React from 'react';
import xtend from 'xtend';

var defaultStyles = {
    marginBottom: '1em',
    border: '1px solid gray',
    borderLeft: '4px solid #5bc0de',
    padding: '0.5em 1em',
    backgroundColor: 'white'
};

function ListItem (_props) {
    var props = xtend(_props);
    var classes = ('clearfix ' + (props.className || '')).trim();
    var styles = props.style;
    delete props.style;
    delete props.className;

    return <li
        className={classes}
        style={xtend(defaultStyles, styles)}
        {...props}
    >
        <span className="list-item-title" style={{
            display: 'inline-block',
            padding: '6px 0'
        }}>
            {props.title}
        </span>

        {props.children}
    </li>;
}

function ListCard (props) {
    var classes = ('clearfix ' + props.className).trim();
    var styles = props.style;

    return <li
        className={classes + ' panel panel-default'}
        style={xtend(defaultStyles, { padding: 0 }, styles)}
        {...props}
    >
        <div className="panel-heading">
            {props.title}
        </div>

        <div className="panel-body">
            {props.children}
        </div>
    </li>;
}

export default {
    ListItem: ListItem,
    ListCard: ListCard
};

